"use client";

import { motion } from "framer-motion";
import { usePrefs } from "./prefs-provider";

export function HeroVisual() {
  const { t } = usePrefs();
  return (
    <div className="relative mx-auto aspect-[4/5] w-full max-w-md lg:max-w-none">
      <div className="absolute inset-x-8 top-10 h-40 rounded-full bg-[var(--mint)]/60 blur-3xl" />
      <motion.div
        className="absolute inset-0"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="absolute left-1/2 top-6 h-72 w-72 -translate-x-1/2 rounded-full border border-[var(--teal)]/20 animate-pulse-ring" />
        <div
          className="absolute left-1/2 top-6 h-72 w-72 -translate-x-1/2 rounded-full border border-[var(--teal)]/15 animate-pulse-ring"
          style={{ animationDelay: "0.8s" }}
        />

        <div className="absolute inset-x-10 top-16 bottom-8 rounded-[2rem] border border-white/70 bg-[linear-gradient(180deg,#12352f_0%,#0f6b5c_48%,#147a69_100%)] p-3 shadow-[var(--shadow)] animate-float-y">
          <div className="flex h-full flex-col overflow-hidden rounded-[1.5rem] bg-[#071a16] text-white">
            <div className="flex items-center justify-between border-b border-white/10 px-4 py-3 text-xs">
              <span className="font-medium text-white/70">{t.hero.linked}</span>
              <span className="rounded-md bg-emerald-400/20 px-2 py-0.5 text-emerald-300">{t.hero.protected}</span>
            </div>
            <div className="space-y-3 p-4">
              {[
                { t: t.hero.group, d: t.hero.groupD, tone: "warn" },
                { t: t.hero.unknown, d: t.hero.unknownD, tone: "ok" },
                { t: t.hero.media, d: t.hero.mediaD, tone: "alert" },
              ].map((row) => (
                <div key={row.t} className="rounded-xl border border-white/10 bg-white/5 px-3 py-2.5">
                  <div className="flex items-center justify-between gap-2">
                    <p className="text-sm font-semibold">{row.t}</p>
                    <span
                      className={`h-2 w-2 rounded-full ${
                        row.tone === "ok" ? "bg-emerald-400" : row.tone === "warn" ? "bg-amber-400" : "bg-rose-400"
                      }`}
                    />
                  </div>
                  <p className="mt-1 text-xs text-white/55">{row.d}</p>
                </div>
              ))}
            </div>
            <div className="mt-auto border-t border-white/10 px-4 py-3">
              <p className="text-[11px] uppercase tracking-[0.18em] text-white/40">{t.hero.session}</p>
              <p className="mt-1 text-sm font-medium text-emerald-300">{t.hero.live}</p>
            </div>
          </div>
        </div>

        <motion.div
          className="absolute -left-2 top-28 rounded-2xl border border-[var(--line)] bg-[var(--foam)]/90 px-4 py-3 shadow-lg backdrop-blur"
          initial={{ opacity: 0, x: -16 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.45, duration: 0.6 }}
        >
          <p className="text-xs font-semibold text-[var(--ink-soft)]">{t.hero.parent}</p>
          <p className="mt-1 text-sm font-bold text-[var(--ink)]">{t.hero.parentD}</p>
        </motion.div>

        <motion.div
          className="absolute -right-1 bottom-24 rounded-2xl border border-[var(--line)] bg-[var(--foam)]/90 px-4 py-3 shadow-lg backdrop-blur"
          initial={{ opacity: 0, x: 16 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.65, duration: 0.6 }}
        >
          <p className="text-xs font-semibold text-[var(--ink-soft)]">{t.hero.child}</p>
          <p className="mt-1 text-sm font-bold text-[var(--ink)]">{t.hero.childD}</p>
        </motion.div>
      </motion.div>
    </div>
  );
}
